<script>
    import TopBackground from './top-background.svelte'
    import TopTextIcons from './top-text-icons.svelte'
    import Selector from './selector.svelte'
    import Bonus from './bonus.svelte'
    import LinkIcons from './link-icons.svelte'

    export let theme
    export let primary
    export let secondary

    const staticAssetPrefix = (window.fanxVersion && window.fanxVersion.urlPrefix) || '/'

    $: backgroundImage = `${staticAssetPrefix}img/onboarding/${
        theme === true ? 'event-background-dark.png' : 'event-background.png'
    }`
</script>

<style>
    .fno-preview {
        width: 414px;
        height: 896px;
        position: relative;
        margin-bottom: 25px;
    }
</style>

<div class="fno-preview" style="background-image: url({backgroundImage});">
    <TopBackground fill={primary} />
    <Selector fill={secondary} />
    <LinkIcons fill={primary} />
    <Bonus />
    <TopTextIcons fill={primary} />
</div>
